import { render, staticRenderFns } from "./AddEventManager.vue?vue&type=template&id=b6123c68&scoped=true"
import script from "./AddEventManager.vue?vue&type=script&lang=ts"
export * from "./AddEventManager.vue?vue&type=script&lang=ts"
import style0 from "./AddEventManager.vue?vue&type=style&index=0&id=b6123c68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6123c68",
  null
  
)

export default component.exports